// This module was taken from https://www.npmjs.com/package/quill-image-drop-and-paste
// and modified a little bit according to our needs. Also the entry point of the package (index.js)
// was left without compiled into a backwards compatible version of JavaScript.

export default class ImageDropAndPaste {
  constructor(quill, options = {}) {
    this.quill = quill;
    this.options = options;
    this.quill.root.addEventListener('drop', e => this.handleDrop(e), false);
    this.quill.root.addEventListener('paste', e => this.handlePaste(e), false);
  }

  // handle image drop event
  handleDrop(e) {
    e.preventDefault();
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      if (document.caretRangeFromPoint) {
        const selection = document.getSelection();
        const range = document.caretRangeFromPoint(e.clientX, e.clientY);
        if (selection && range) {
          selection.setBaseAndExtent(range.startContainer, range.startOffset, range.startContainer, range.startOffset);
        }
      }
      this.readFiles(e.dataTransfer.files, (dataUrl, type) => {
        if (typeof this.options.onImageDropOrPaste === 'function') {
          const index = this.quill.getSelection()
            ? this.quill.getSelection().index
            : this.quill.getLength() - 1;
          this.options.onImageDropOrPaste(this.quill, dataUrl, type, '', index);
        } else {
          this.insert.call(this, dataUrl, type);
        }
      }, e);
    }
  }

  // handle image paste event
  handlePaste(e) {
    if (e.clipboardData && e.clipboardData.items && e.clipboardData.items.length) {
      this.readFiles(e.clipboardData.items, (dataUrl, type) => {
        if (typeof this.options.onImageDropOrPaste === 'function') {
          const index = this.quill.getSelection()
            ? this.quill.getSelection().index
            : this.quill.getLength() - 1;
          this.options.onImageDropOrPaste(this.quill, dataUrl, type, '', index);
        } else {
          this.insert(dataUrl, type);
        }
      }, e);
    }
  }

  // read the files
  readFiles(files, callback, e) {
    [].forEach.call(files, file => {
      const { type, name } = file;
      if (!type.match(/^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i)) return;
      e.preventDefault();
      // eslint-disable-next-line no-undef
      const reader = new FileReader();
      reader.onload = evt => {
        callback(evt.target.result, type, name);
      };
      const blob = file.getAsFile ? file.getAsFile() : file;
      // eslint-disable-next-line no-undef
      if (blob instanceof Blob) reader.readAsDataURL(blob);
    });
  }

  // insert into the editor
  insert(dataUrl) {
    const index = (this.quill.getSelection() || {}).index || this.quill.getLength();
    this.quill.insertEmbed(index, 'image', dataUrl, 'user');
  }
}
